(() => {
  if (window.CWISearch) return;
  const script = document.currentScript;
  const indexUrl = script?.dataset.indexUrl;
  const root = window.Shopify?.routes?.root || '/';
  let indexPromise;
  const normalize = (value) => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  const withoutZeros = (value) => value.replace(/^([A-Z]*)0+(?=\d)/, '$1');
  const categories = [
    [/\bcoveralls?\b/, 'womens-coveralls', 'Women’s Coveralls'],
    [/\b(overalls?|bibs?)\b/, 'womens-overalls', 'Women’s Overalls'],
    [/\b(shorts?)\b/, 'womens-shorts', 'Women’s Shorts'],
    [/\b(pants?|trousers?)\b/, 'womens-pants', 'Women’s Pants'],
    [/\b(jackets?|parkas?|coats?)\b/, 'womens-jackets-and-parkas', 'Women’s Jackets and Parkas'],
    [/\b(hoodies?|sweaters?|sweatshirts?)\b/, 'womens-sweaters-and-hoodies', 'Women’s Sweaters and Hoodies'],
    [/\b(t[ -]?shirts?|tees?|tshirts?)\b/, 'womens-t-shirts', 'Women’s T-Shirts'],
    [/\bshirts?\b/, 'womens-work-shirts', 'Women’s Work Shirts'],
    [/\bvests?\b/, 'womens-vests', 'Women’s Vests']
  ];
  function category(query) {
    const term = query.toLowerCase().replace(/[’']/g, '');
    if (!/\b(womens?|ladies|ladys?|females?)\b/.test(term)) return null;
    const match = categories.find(([pattern]) => pattern.test(term));
    return { url: root + 'collections/' + (match?.[1] || 'womens-clothing'), title: match?.[2] || 'Women’s Workwear' };
  }
  function isPart(query) {
    return /^[A-Za-z0-9./_-]+$/.test(query.trim()) && /\d/.test(query) && normalize(query).length >= 3;
  }
  function matchParts(query, records) {
    if (!isPart(query)) return [];
    const needle = normalize(query);
    const shortNeedle = withoutZeros(needle);
    return records.filter((product) => product.c.some((code) => {
      const value = normalize(code);
      return value.includes(needle) || withoutZeros(value).includes(shortNeedle);
    })).sort((a, b) => {
      const exact = (p) => p.c.some((c) => normalize(c) === needle);
      return Number(exact(b)) - Number(exact(a));
    });
  }
  async function resolve(query) {
    const destination = category(query);
    if (destination) return { category: destination, query };
    if (!isPart(query)) return { query };
    try {
      indexPromise ||= fetch(indexUrl, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error('Part lookup unavailable');
        return response.json();
      }).catch((error) => { indexPromise = null; throw error; });
      const matches = matchParts(query, await indexPromise);
      if (!matches.length) return { query };
      const terms = [...new Set(matches.map((product) => product.q))];
      return { query: terms.map((term) => '"' + term.replace(/["\\]/g, '') + '"').join(' OR '), matches };
    } catch (_) { return { query }; }
  }
  window.CWISearch = { category, isPart, matchParts, resolve };
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches?.('form.search') || form.dataset.cwiPassthrough === 'true') return;
    const input = form.querySelector('input[name="q"]');
    const original = input?.value.trim();
    if (!original || (!category(original) && !isPart(original))) return;
    if (form.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')) return;
    event.preventDefault();
    const resolved = await resolve(original);
    if (input.value.trim() !== original) return;
    if (resolved.category) {
      window.location.assign(resolved.category.url);
    } else if (resolved.matches?.length) {
      const url = new URL(form.action, window.location.href);
      url.search = new URLSearchParams(new FormData(form)).toString();
      url.searchParams.set('q', resolved.query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('cwi_original', original);
      window.location.assign(url.toString());
    } else {
      form.dataset.cwiPassthrough = 'true';
      try { form.requestSubmit(); } finally { delete form.dataset.cwiPassthrough; }
    }
  }, true);
  const original = new URLSearchParams(window.location.search).get('cwi_original');
  if (original && window.location.pathname.endsWith('/search')) {
    document.querySelectorAll('input[name="q"]').forEach((input) => { input.value = original; });
  }
})();
